import apiClient from "../utils/apiClient";

// Upload API endpoints
const uploadApi = {
  // Upload research opportunities from Excel
  uploadOpportunities: async (data) => {
    try {
      return await apiClient("/research/bulk-upload", "POST", {
        opportunities: data,
      });
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Validate Excel data before upload
  validateOpportunities: async (data) => {
    try {
      return await apiClient("/research/validate", "POST", {
        opportunities: data,
      });
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Get upload history
  getUploadHistory: async (params = {}) => {
    try {
      const queryString = new URLSearchParams(params).toString();
      const endpoint = queryString
        ? `/research/upload-history?${queryString}`
        : "/research/upload-history";
      return await apiClient(endpoint, "GET");
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Download template Excel file
  downloadTemplate: async () => {
    try {
      return await apiClient("/research/download-template", "GET");
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },
};

export default uploadApi;
